import { gsap } from 'gsap';
import { isOdd, isEven } from '../core'

/*
*	Slideshow using canvas
*/
$.fn.KeywordsCanvas = function() {
  let self = this
  self.canvas = undefined

  self.keywords = self.data('keywords')
  if (!Array.isArray(self.keywords)) {
    self.keywords = self.keywords.split(',');
  }
  self.graphics_files = {
    x: '/img/badges/x.svg',
  }
  self.graphics = {}

  self.status = {
    is_odd: true,
    frame: 0,
    angle: 0,
    graphics_loaded: 0,
  }

  self.ctx = function() {
    return self.canvas.get(0).getContext('2d')
  }

  self.px = function(number) {
    return number * window.devicePixelRatio
  }

  self.drawRotated = function (context, image, angle, drawX, drawY, drawWidth, drawHeight, axisX, axisY) {
    angle *= Math.PI / 180
    context.translate(drawX, drawY)
    context.rotate(angle)
    context.drawImage(image, -axisX, -axisY, drawWidth, drawHeight)
    context.rotate(-angle)
    context.translate(-drawX, -drawY)
  }

  self.draw = function() {
    /* context */
    let ctx = self.ctx(),
    scale = $.mlmi.mobile.isMobile ? .35 : 1,
    offset = self.px(1000 * scale),
    x = -offset,
    y = self.px(100 * scale),
    spacer = self.px(80 * scale),
    row = 0
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
    self.canvas.attr('width', Math.floor(self.px(self.width()))).attr('height', Math.floor(self.px(self.height())))
    self.status.frame += 1 * scale

    /* draw first word */
    ctx.font = 'bold ' + self.px(43 * scale) + 'px ArtegraSansCondensed'
    ctx.fillStyle = '#E2DAC9'
    ctx.globalAlpha = .15
    let wordSize1 = ctx.measureText(self.keywords[0]),
    wordSize2 = ctx.measureText(self.keywords[1]),
    phraseSize = 0

    while (y < self.px(self.height()) || isOdd(row)) {
      x += (self.status.is_odd ? -self.status.frame : self.status.frame)
      while (x < self.px(self.width()) + (offset * 2)) {
        ctx.fillText(self.keywords[0], x, y)
        x += wordSize1.width + spacer
        self.drawRotated(ctx, self.graphics.x, self.status.angle, x + self.px(25 * scale), y - self.px(40 * scale) + self.px(25 * scale), self.px(50 * scale), self.px(50 * scale), self.px(25 * scale), self.px(25 * scale))
        x += self.px(50 * scale) + spacer
        ctx.fillText(self.keywords[1], x, y)
        x += wordSize2.width + spacer
        self.drawRotated(ctx, self.graphics.x, self.status.angle, x + self.px(25 * scale), y - self.px(40 * scale) + self.px(25 * scale), self.px(50 * scale), self.px(50 * scale), self.px(25 * scale), self.px(25 * scale))
        x += self.px(50 * scale) + spacer
      }
      phraseSize = wordSize1.width + wordSize2.width + spacer + spacer + spacer + spacer + self.px(50 * scale) + self.px(50 * scale)
      if (self.status.is_odd) {
        x = -offset - (phraseSize / 2)
        self.status.is_odd = false
      } else {
        x = -offset
        self.status.is_odd = true
      }
      row += 1
      y += self.px(100 * scale)
    }

    if (self.status.frame >= phraseSize) {
      self.status.frame = 0
    }

    /* next frame */
    requestAnimationFrame(self.draw)
  }

  self.ready = function() {
    let total_graphics = Object.keys(self.graphics_files).length
    self.status.graphics_loaded += 1

    /* ready */
    if (self.status.graphics_loaded >= total_graphics) {
      let rotation = gsap.timeline({
        repeat: -1,
        repeatDelay: 1,
        repeatRefresh: true,
      }).to(self.status, {
        angle: '+=45',
        duration: 1,
        ease: 'power3.inOut',
      })
      self.draw()
    }
  }

  self.initialize_load = function() {
    /* canvas element */
    self.canvas = $('<canvas>').attr('width', self.px(self.width())).attr('height', self.px(self.height())).addClass('keywords-canvas')
    self.append(self.canvas)

    /* graphics elements */
    for (let key in self.graphics_files) {
      let thumbnail = $('<img>').attr('src', self.graphics_files[key])
      thumbnail.on('load', function() {
        self.graphics[key] = $(this).get(0)
        self.ready()
      })
    }
  }

  return function() {
    self.initialize_load()
    return self
  }()
}
